import { render, staticRenderFns } from "./XmlImport.vue?vue&type=template&id=ca8e6fa8&scoped=true&"
import script from "./XmlImport.vue?vue&type=script&lang=js&"
export * from "./XmlImport.vue?vue&type=script&lang=js&"
import style0 from "./XmlImport.vue?vue&type=style&index=0&id=ca8e6fa8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8e6fa8",
  null
  
)

export default component.exports